import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent, SohoModalDialogService, SohoBusyIndicatorDirective } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { Router, NavigationExtras } from "@angular/router";
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';
import { filterPayCurveColumns } from '../services/fiscal-year.helper';

@Component({
  selector: 'app-role-pay-curve-mapping',
  templateUrl: './role-pay-curve-mapping.component.html',
  styleUrls: ['./role-pay-curve-mapping.component.css']
})
export class RolePayCurveMappingComponent implements OnInit {
  @ViewChild(SohoDataGridComponent) sohoDataGridComponent!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  public data!: any[];
  public grid_Columns!: SohoDataGridColumn[];
  public filteredArray: any[] = [];
  public GrdRequests: any;
  public filteredRequests: any;
  public filteredIds: any[] = [];
  showBusy = true;
  Message = "Loading...";
  emailAddress!: string;
  userData = new UserData();

  constructor(private capacityModelService: CapacityModelService,
    private router: Router,
    private ngZone: NgZone,
    private authhelper: AuthHelper,
    private modalService: SohoModalDialogService) { }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {
      this.emailAddress = this.userData.Email;
    }
    this.GetRolePayCurveMappings();
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }

  GetRolePayCurveMappings() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
    this.capacityModelService.GetRolePayCurveMappings().subscribe(
      mappings => {
        this.data = mappings;
        this.grid_Columns = filterPayCurveColumns(this.gridColumns);
        if (this.data != null) {
          this.GrdRequests = $("#RolePayCurveMappingGrid").datagrid().data();
          this.GrdRequests.datagrid.renderRows();
        }
        this.stop();
      },
      (error: Response) => {
        this.stop();
        console.log(error);
        this.ShowAlert("Alert", "Error while loading the mappings.");
      }
    );
  }

  AddNew() {
    this.ngZone.run(() => this.router.navigate(["AddRolePayCurveMapping"])).then();
  }

  onClick(args: any) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        uniqueid: args["0"].item.uniqueid
      }
    };
    this.ngZone.run(() => this.router.navigate(["EditRolePayCurveMapping"], navigationExtras)).then();
  }

  DeleteMappings() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {
      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.uniqueid;
          this.filteredArray.push(this.filteredIds);
        }
      }
    }
    if (this.filteredArray.length > 0) {
      this.ShowConfirmDelete(selectedid);
    }
    else {
      this.ShowAlert("Information", "Please select at least one mapping to delete.");
    }
  }

  ShowConfirmDelete(selectedid: any[]) {
    const dialogRef1 = this.modalService
      .message("<h2>Are you sure you want to delete the selected mapping(s)?</h2>")
      .buttons([
        {
          text: "Yes",
          click: () => {
            dialogRef1.close("Yes");
            this.ConfirmDelete(selectedid);
          }
        },
        {
          text: "No",
          click: () => {
            dialogRef1.close("No");
          },
          isDefault: true
        }
      ])
      .title("Confirm Delete")
      .open()
      .frameHeight(1000);
  }

  ConfirmDelete(selectedid: any[]) {
    let filterid!: any;
    this.start();
    for (var i = 0; i < this.filteredArray.length; i++) {
      filterid = <JSON><unknown>{ "uniqueid": this.filteredArray[i], "userlogin": this.emailAddress == null ? "" : this.emailAddress };
      selectedid.push(filterid);
    }
    this.capacityModelService.DeleteRolePayCurveMappings(selectedid).subscribe(
      response => {
        this.ShowAlert("Confirmation", "Mapping(s) deleted successfully.");
        this.stop();
        this.GetRolePayCurveMappings();
      },
      (error: Response) => {
        console.log(error);
        this.stop();
        this.ShowAlert("Alert", "Error while deleting the mapping(s).");
      }
    );
  }

  ShowAlert(Title: any, Message: any) {
    const dialogRef1 = this.modalService
      .message("<h2>" + Message + "</h2>")
      .buttons([
        {
          text: "Ok",
          click: () => {
            dialogRef1.close("Ok");
          },
          isDefault: true
        }
      ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }

  gridColumns = [
    {
      id: 'selectionCheckbox',
      sortable: false,
      resizable: false,
      formatter: Soho.Formatters.SelectionCheckbox,
      align: 'center'
    },
    {
      id: "button-formatter",
      name: "Edit",
      text: "Edit Row",
      icon: "edit",
      align: "center",
      sortable: false,
      formatter: Soho.Formatters.Button,
      click: (e: any, args: any) => this.onClick(args)
    },
    {
      id: "uniqueid",
      name: "ID",
      field: "uniqueid",
      hidden: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "roletype",
      name: "Role Type",
      field: "roletype",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "paycurve1",
      name: "Pay Curve 1",
      field: "paycurve1",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "paycurve2",
      name: "Pay Curve 2",
      field: "paycurve2",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "paycurve3",
      name: "Pay Curve 3",
      field: "paycurve3",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "paycurve4",
      name: "Pay Curve 4",
      field: "paycurve4",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "paycurve5",
      name: "Pay Curve 5",
      field: "paycurve5",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "createdby",
      name: "Created By",
      field: "createdby",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "created",
      name: "Created On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    },
    {
      id: "updatedby",
      name: "Updated By",
      field: "updatedby",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "updated",
      name: "Updated On",
      field: "updated",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    }
  ];
}
